export const zh = {
    lineType:"线路类型",
    no: '单据编号',
    applyType: '类型',
    subject: '主题',
    shortlistedSuppliers: '入围供应商',
    quotationType: '报价类型',
    sourcing: '报价确认申请单',
    sourcingStatus: '报价确认状态',
    status: '申请单状态',
    quotationStatus: '报价状态',
    quotationRound: '报价轮次',
    lineDetail: '线路报价明细',
    dc: '到货仓库(DC)',
    temperature: '温区',
    transportaionMethod: '运输方式',
    originalSupplier: '原供应商',
    originalPrice: '原价格',
    unit: '结算单位',
    effectiveBeginDate: '有效开始日期',
    detailCreate: '明细创建',
    round: '轮次',
    roundStatus: '轮次状态',
    newRound: '创建新轮次',
    endQuotaion: '结束询价',
    resumeQuotation: '恢复询价',
    confirmPrice: '价格确认',
    roundRemark: '轮次说明',
    supplierCode: '供应商编号',
    supplierName: '供应商名称',
    whetherToIssue: '本轮次是否发放',
    roundsFixed: '轮次已报价确认',
    canNotConfirm: '已创建新轮次,不能报价确认',
    annualTotalCostSave: '预估年总费用保存',
    supplier: '供应商',
    shippingCity: '发货市',
    arrivalAarehouse: '到货仓库',
    priceNotTax: '报价（不含税）',
    currency: '币种',
    estimatedAnnualTotalCost: '预估年总费用',
    quoteSubmitDate: '报价提交日期',
    historyQuote: '历史报价',
    quoteHistory: '报价历史',
    roundAttachment: '轮次附件',
    quoteAttachment: '报价附件',
    sourcingApprovalStatus: '报价确认审批状态',
    currentLinePrice: '现行线路价格',

    selectDelApply: '请选择需要删除的申请单',
    delApplyParam: '只有草稿状态的申请单才可以删除',
    selectCloseApply: '请选择需要作废的申请单',
    selectApplyType: '请选择申请单类型',
    selectSuppliers: '请选择入围供应商',
    selectQuotationType: '请选择报价类型',
    selectTemperature: '请选择温区',
    selectPickupPoint: '请选择提货点',
    selectDcName: '请选择到货仓库',
    selectDelLine: '请选择需要删除的明细',

    fillForUnit:'请填写结算单位',
    fillForEffectiveBeginDate:'请填写有效开始日期',

    selectEndQuote: '请选择需要结束的询价',
    selectCompletedQuotationStatus: '请选择报价状态为报价完成的单据进行结束操作！',
    closeRFQSuccess: '结束询价成功',
    selectResumeQuote: '请选择需要恢复的询价!',
    resumeQuoteCondition: '只有最新轮次且轮次状态为结束询价的才能进行恢复操作！',
    resumeRFQSuccess: '恢复询价成功',
    selectNewRoundQuote: '请选择需创建新轮次的询价！',
    newRoundCondition: '只有报价完成且最新轮次才可以进行新轮次创建！',
    selectPublishSupplier: '请选择需要发放的供应商',
    selectPriceDetermination: '请选择需要价格确定的询价！',
    pleaseSelectQuoteFinishedData: '请选择结束询价的数据！',
    pleaseConfirmEndQuote: '请确认询价结束',
    lineStatus: '条目状态',
    sureSubmit: '是否确认提交本次报价',
    pleaseSelectNextNextMonthDate: "请至少选择下个月作为产品有效开始日期",
}

export const en = {
    no: 'Apply no',
    lineType:"线路类型",
    applyType: 'Type',
    subject: 'Subject',
    shortlistedSuppliers: 'Suppliers',
    quotationType: 'Quotation type',
    sourcing: 'Sourcing',
    sourcingStatus: 'Sourcing status',
    status: 'Apply status',
    quotationStatus: 'Quotation status',
    quotationRound: 'Round',
    lineDetail: 'Line quotation details',
    dc: 'DC',
    temperature: 'Warm area',
    transportaionMethod: 'Transport',
    originalSupplier: 'Original supplier',
    originalPrice: 'Original price',
    unit: 'Unit',
    effectiveBeginDate: 'Effective start date',
    detailCreate: 'Detail creation',
    round: 'Round',
    roundStatus: 'Round status',
    newRound: 'New round',
    endQuotaion: 'Closing enquiry',
    resumeQuotation: 'Resume enquiry',
    confirmPrice: 'Price determination',
    roundRemark: 'Round remark',
    supplierCode: 'Supplier no',
    supplierName: 'Supplier name',
    whetherToIssue: 'Whether to issue',
    roundsFixed: 'Rounds fixed',
    canNotConfirm: 'New round has been created, unable to fix point',
    annualTotalCostSave: 'Saving of estimated annual total cost',
    supplier: 'Supplier',
    arrivalAarehouse: 'Arrival warehouse',
    shippingCity: 'Shipping city',
    priceNotTax: 'Quotation (excluding tax)',
    currency: 'Currency',
    estimatedAnnualTotalCost: 'Estimated annual total cost',
    quoteSubmitDate: 'Quotation submission date',
    historyQuote: 'Historical quotation',
    quoteHistory: 'Quote history',
    roundAttachment: 'attachment',
    quoteAttachment: 'Quote attachment',
    sourcingApprovalStatus: 'Sourcing approval status',
    currentLinePrice: 'Current line price',

    selectDelApply: 'Please select the application form to be deleted',
    delApplyParam: 'Only application forms in draft status can be deleted',
    selectCloseApply: 'Please select the application form to be closed!',
    selectApplyType: 'Please select application form type',
    selectSuppliers: 'Please select the shortlisted supplier',
    selectQuotationType: 'Please select quotation type',
    selectTemperature: 'Please select the temperature zone',
    selectPickupPoint: 'Please select pick up point',
    selectDcName: 'Please select the arrival warehouse',
    selectDelLine: 'Please select the details to be deleted',

    selectEndQuote: 'Please select the inquiry to be closed',
    selectCompletedQuotationStatus: 'Please select the document whose quotation status is quotation completed for operation!',
    closeRFQSuccess: 'RFQ closed successfully',
    selectResumeQuote: 'Please select the inquiry to be recovered!',
    resumeQuoteCondition: 'Only the latest round with end inquiry status can be recovered!',
    resumeRFQSuccess: 'Resume inquiry succeeded',
    selectNewRoundQuote: 'Please select the inquiry to create a new round!',
    newRoundCondition: 'Only the quotation is completed and the latest round can be created!',
    selectPublishSupplier: 'Please select the supplier to be released',
    selectPriceDetermination: 'Please select the inquiry that requires price determination!',
    pleaseConfirmEndQuote: 'Please confirm the end of inquiry',
    pleaseSelectQuoteFinishedData: 'Please select quote finished data！',
    lineStatus: 'Detail state',
    sureSubmit: 'Are you sure to submit this quotation',
    pleaseSelectNextNextMonthDate: "Please select at least the next-next month as the effective start date of the product",
}